import { MAP__serializable } from '@shared/dto/_base/MAP__serializable';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { ENUM__field_graph_interaction } from '../../../_fields/_base/_enums/ENUM__field_graph_interaction';
import { FIELD__list_lora } from '../../../_fields/_primitives/list/FIELD__list_lora';
import { FIELD_GRID2D_MODE__all_loras_except_one } from '../../../_fields/ml_asset/guidance_lora/FIELD_GRID2D_MODE__all_loras_except_one';
import { FIELD_GRID2D_MODE__lora_after_lora } from '../../../_fields/ml_asset/guidance_lora/FIELD_GRID2D_MODE__lora_after_lora';
import { FIELD_GRID2D_MODE__lora_vs_lora } from '../../../_fields/ml_asset/guidance_lora/FIELD_GRID2D_MODE__lora_vs_lora';
import { FIELD_GRID2D_MODE__single_lora_generation } from '../../../_fields/ml_asset/guidance_lora/FIELD_GRID2D_MODE__single_lora_generation';
import { DTO_GRAPH__instance } from '../../../_graph/DTO_GRAPH__instance';
import { ENUM__invocation_type } from '../../_base/ENUM__invocation_type';
import { INVOCATION_SD__base } from '../INVOCATION_SD__base';

export class INVOCATION_SD__lora_select extends INVOCATION_SD__base {
  /*
   * STATIC FIELDS
   */

  static _class_name_static: string = ENUM__dto_class_name.INVOCATION_SD__LORA_SELECT;

  /*
   * INPUTS
   */
  @FIELD__list_lora.init_as_input(
    {
      item_meta: MAP__serializable.from_object({ graph__interaction: ENUM__field_graph_interaction.HIDDEN, ui__has_component: true }),
    },
    { data__reset_if_not_linked: false, field_role: '📦 LoRas' },
  )
  loras!: FIELD__list_lora;

  @FIELD_GRID2D_MODE__lora_vs_lora.init_as_input(
    {},
    {
      graph__interaction: ENUM__field_graph_interaction.VISIBLE_NON_CONNECTABLE,
      grid2d__can_be_dimension: true,
      ui__has_component: true,
      field_role: 'Lora vs. Lora',
    },
  )
  grid2d_mode__lora_vs_lora!: FIELD_GRID2D_MODE__lora_vs_lora;

  @FIELD_GRID2D_MODE__lora_after_lora.init_as_input(
    {},
    {
      graph__interaction: ENUM__field_graph_interaction.VISIBLE_NON_CONNECTABLE,
      grid2d__can_be_dimension: true,
      ui__has_component: true,
      field_role: 'Lora after Lora',
    },
  )
  grid2d_mode__lora_after_lora!: FIELD_GRID2D_MODE__lora_after_lora;

  @FIELD_GRID2D_MODE__single_lora_generation.init_as_input(
    {},
    {
      graph__interaction: ENUM__field_graph_interaction.VISIBLE_NON_CONNECTABLE,
      grid2d__can_be_dimension: true,
      ui__has_component: true,
      field_role: 'Single Lora Generation',
    },
  )
  grid2d_mode__single_lora_generation!: FIELD_GRID2D_MODE__single_lora_generation;

  @FIELD_GRID2D_MODE__all_loras_except_one.init_as_input(
    {},
    {
      graph__interaction: ENUM__field_graph_interaction.VISIBLE_NON_CONNECTABLE,
      grid2d__can_be_dimension: true,
      ui__has_component: true,
      field_role: 'All Loras Except One',
    },
  )
  grid2d_mode__all_loras_except_one!: FIELD_GRID2D_MODE__all_loras_except_one;

  /*
   * EVENTS
   */

  /*
   * METHODS
   */

  constructor() {
    super(ENUM__invocation_type.SD__LORA_SELECT);
  }

  post_init(): void {
    super.post_init();
    this.loras.meta.ui__has_component = true;
  }

  prepare_for_usage_in(graph: DTO_GRAPH__instance) {
    super.prepare_for_usage_in(graph);

    /*
     *
     */

    let loras = this.loras.find_source(graph).get_enabled_and_non_zero_weight_items();

    this.grid2d_mode__lora_after_lora.init_loras(loras);
    this.grid2d_mode__lora_vs_lora.init_loras(loras);
    this.grid2d_mode__single_lora_generation.init_loras(loras);
    this.grid2d_mode__all_loras_except_one.init_loras(loras);
  }
}
